import React from "react";
import PropTypes from "prop-types";
import DOMPurify from "dompurify";
import HeaderPublico from "../../components/HeaderPublico";
import FooterPublico from "../../components/FooterPublico";
import LegalBackLink from "../../components/LegalBackLink";
import useLegalPageContent from "../../hooks/useLegalPageContent";
import { buildPrestadorIdentity } from "../../utils/buildPrestadorIdentity";
import "./Terminos.css";

function PrestadorLine({ label, value }) {
  if (!value) {
    return null;
  }
  return (
    <li>
      <strong>{label}:</strong> {value}
    </li>
  );
}

PrestadorLine.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
};

PrestadorLine.defaultProps = {
  value: "",
};

function TerminosFallbackContent({ prestador }) {
  const identity = buildPrestadorIdentity(prestador);

  return (
    <>
      {identity.hasIdentity ? (
        <section>
          <h2>1. Identificación del prestador</h2>
          <p>Titular de la plataforma:</p>
          <ul>
            <PrestadorLine label="Razón social" value={identity.nombreFiscal} />
            <PrestadorLine label="NIF/CIF" value={identity.nif} />
            <PrestadorLine label="Domicilio social" value={identity.domicilio} />
            <PrestadorLine label="Email" value={identity.email} />
            <PrestadorLine label="Teléfono" value={identity.telefono} />
          </ul>
        </section>
      ) : null}
      <section>
        <h2>{identity.hasIdentity ? "2. Aceptación de los términos" : "Aceptación de los términos"}</h2>
        <p>
          Al acceder y utilizar esta plataforma de formación, usted acepta estar sujeto a estos
          Términos y Condiciones. Si no está de acuerdo con alguna parte de los mismos, no debe
          utilizar nuestros servicios.
        </p>
      </section>
    </>
  );
}

TerminosFallbackContent.propTypes = {
  prestador: PropTypes.shape({
    nombreFiscal: PropTypes.string,
    nif: PropTypes.string,
    direccion: PropTypes.string,
    ciudad: PropTypes.string,
    provincia: PropTypes.string,
    codigoPostal: PropTypes.string,
    pais: PropTypes.string,
    emailFacturacion: PropTypes.string,
    telefonoFacturacion: PropTypes.string,
  }),
};

TerminosFallbackContent.defaultProps = {
  prestador: null,
};

export default function Terminos() {
  const { contentHtml, updatedLabel, prestador, loading } = useLegalPageContent("terminos");
  const sanitizedHtml = contentHtml.trim()
    ? DOMPurify.sanitize(contentHtml)
    : "";

  return (
    <div className="pagina-publicitaria">
      <HeaderPublico cursos={[]} />
      <div className="legal-content">
        <h1>Términos y Condiciones</h1>
        <p className="legal-updated">{updatedLabel || "Última actualización: Febrero 2026 (v1)"}</p>

        {loading ? <p>Cargando…</p> : null}
        {!loading && sanitizedHtml ? (
          <div
            className="legal-content-body"
            dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
          />
        ) : null}
        {!loading && !sanitizedHtml ? <TerminosFallbackContent prestador={prestador} /> : null}

        <p className="legal-back">
          <LegalBackLink />
        </p>
      </div>
      <FooterPublico />
    </div>
  );
}
